(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rocket-17track-shell"] && !Shopify.designMode) return;
  try {
    const trackingPage = document.querySelector('.rg-17track-page');
  const translationConfig = document.querySelector('#rg-17track-translation-config');

  if (trackingPage && translationConfig) {
    const statusTranslations = [
      {
        pattern: /Manifest (erstellt|created)/gi,
        replacement: translationConfig.dataset.manifestStatus
      },
      {
        pattern: /Arrived at destination/gi,
        replacement: translationConfig.dataset.arrivedStatus
      }
    ];

    const translateValue = (value) => {
      return statusTranslations.reduce((translated, status) => {
        return translated.replace(status.pattern, status.replacement);
      }, value);
    };

    const translateTextNode = (node) => {
      if (!node.nodeValue) return;
      const translatedValue = translateValue(node.nodeValue);
      if (translatedValue !== node.nodeValue) {
        node.nodeValue = translatedValue;
      }
    };

    const translateTrackingContent = (root) => {
      if (root.nodeType === Node.TEXT_NODE) {
        translateTextNode(root);
        return;
      }

      if (root.nodeType !== Node.ELEMENT_NODE) return;

      const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
      let textNode = walker.nextNode();

      while (textNode) {
        translateTextNode(textNode);
        textNode = walker.nextNode();
      }

      ['title', 'aria-label'].forEach((attribute) => {
        root.querySelectorAll(`[${attribute}]`).forEach((element) => {
          const value = element.getAttribute(attribute);
          if (!value) return;
          const translatedValue = translateValue(value);
          if (translatedValue !== value) {
            element.setAttribute(attribute, translatedValue);
          }
        });
      });
    };

    translateTrackingContent(trackingPage);

    const trackingObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach(translateTrackingContent);
        if (mutation.type === 'characterData') translateTextNode(mutation.target);
      });
    });

    trackingObserver.observe(trackingPage, {
      childList: true,
      characterData: true,
      subtree: true
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rocket-customs-info"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
  const trigger = event.target.closest('[data-customs-open]');
  if (trigger) {
    const dialog = document.getElementById(trigger.dataset.customsOpen);
    if (dialog && !dialog.open) dialog.showModal();
    return;
  }
  const close = event.target.closest('[data-customs-close]');
  if (close) close.closest('dialog').close();
  if (event.target.matches('.rg-customs-dialog')) {
    const rect = event.target.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) event.target.close();
  }
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rocket-klarna"] && !Shopify.designMode) return;
  try {
    (function(){
  function update(widget){
    var section=widget.closest('[data-product-section]');
    if(!section)return;
    var selector=section.querySelector('[data-product-variant-selector]');
    var option=selector && selector.options[selector.selectedIndex];
    var price=option ? Number(option.dataset.priceRaw) : Number(widget.dataset.unitPrice);
    var quantity=section.querySelector('[data-quantity-input]');
    var count=Math.max(1,Math.floor(Number(quantity && quantity.value)||1));
    var submit=section.querySelector('[data-product-submit]');
    widget.hidden=!(price>0)||!!(submit && submit.disabled);
    var add=widget.querySelector('[data-budget-add]');
    add.disabled=!submit||submit.disabled;
    if(submit)add.textContent=submit.textContent.trim();
    var total=Math.round(price*count);
    var parts=Number(widget.querySelector('[data-budget-parts]').value)||3;
    var format=new Intl.NumberFormat(widget.dataset.locale||'en',{style:'currency',currency:widget.dataset.currency||'CHF'});
    var money=function(cents){return format.format(cents/100);};
    widget.querySelector('[data-budget-inline]').textContent=widget.dataset.monthlyTemplate.replace('__AMOUNT__',money(Math.round(total/12)));
    widget.querySelector('[data-budget-amount]').textContent=money(Math.round(total/parts));
    widget.querySelector('[data-budget-total]').textContent=money(total);
  }
  function updateSection(target){
    var section=target.closest('[data-product-section]');
    if(section)section.querySelectorAll('[data-rg-budget]').forEach(update);
  }
  document.addEventListener('click',function(event){
    var opener=event.target.closest('[data-budget-open]');
    if(opener){var widget=opener.closest('[data-rg-budget]');update(widget);widget.querySelector('dialog').showModal();return;}
    var add=event.target.closest('[data-budget-add]');
    if(add){
      var section=add.closest('[data-product-section]');
      var submit=section && section.querySelector('[data-product-submit]');
      if(submit && !submit.disabled){add.disabled=true;add.closest('dialog').close();submit.click();}
      return;
    }
    var closer=event.target.closest('[data-budget-close]');
    if(closer){closer.closest('dialog').close();return;}
    if(event.target.matches('.rg-budget__dialog')){var rect=event.target.getBoundingClientRect();if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)event.target.close();}
    var quantity=event.target.closest('[data-quantity-minus],[data-quantity-plus]');
    if(quantity)queueMicrotask(function(){updateSection(quantity);});
  });
  document.addEventListener('change',function(event){
    if(event.target.matches('[data-budget-parts]'))update(event.target.closest('[data-rg-budget]'));
    else if(event.target.matches('[data-product-variant-selector],[data-quantity-input]'))updateSection(event.target);
  });
  document.addEventListener('input',function(event){if(event.target.matches('[data-quantity-input]'))updateSection(event.target);});
  function init(){document.querySelectorAll('[data-rg-budget]').forEach(update);}
  document.addEventListener('shopify:section:load',init);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();
  } catch(e) { console.error(e); }
})();

})();
